<script>
    import { Route } from 'svelte-navigator';
    import PrivateRouteGuard from '../guards/PrivateRouteGuard.svelte';

    export let path;
    export let exact = false;
</script>

<Route exact={exact} {path} let:params let:location let:navigate>
    <PrivateRouteGuard>
        <slot {params} {location} {navigate} />
    </PrivateRouteGuard>
</Route>